import CloseRounded from '@material-ui/icons/CloseRounded';
import ShoppingCartOutlined from '@material-ui/icons/ShoppingCartOutlined';

import { SButton } from '@setvi/shared/components';
import type { Resource } from '@setvi/shared/interfaces';

import { usePrintOrderCartAction } from '../../hooks/use-print-order-cart-action';

interface PrintOrderCartButtonProps {
  resource: Resource;
  /** Runs when a customization dialog takes over from the host dialog. */
  onHandOff?: () => void;
}

/** Add to Cart / Remove from Cart, for the resource preview dialog. */
export const PrintOrderCartButton = ({
  resource,
  onHandOff
}: PrintOrderCartButtonProps) => {
  const {
    enabled,
    hidden,
    resolving,
    isInCart,
    label,
    loading,
    disabled,
    toggle
  } = usePrintOrderCartAction(resource, { onHandOff });

  if (!enabled || hidden || resolving) return null;

  return (
    <SButton
      variant="outlined"
      color="primary"
      loading={loading}
      disabled={disabled}
      startIcon={isInCart ? <CloseRounded /> : <ShoppingCartOutlined />}
      onClick={toggle}>
      {label}
    </SButton>
  );
};
